import { render, staticRenderFns } from "./ChefPublicProfile.vue?vue&type=template&id=356090ab&scoped=true&"
import script from "./ChefPublicProfile.vue?vue&type=script&lang=js&"
export * from "./ChefPublicProfile.vue?vue&type=script&lang=js&"
import style0 from "./ChefPublicProfile.vue?vue&type=style&index=0&id=356090ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356090ab",
  null
  
)

export default component.exports